<template>
  <div>
    <ThirdPartyServiceList :account-id="accountId" :third-party-services="thirdPartyServices" />
  </div>
</template>

<script>
import ThirdPartyServiceList from 'Components/AccountThirdPartyServices/ThirdPartyServiceList.vue';
import { middleware } from '@/routes/guards';

export default {
  components: { ThirdPartyServiceList },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
      message: '',
    };
  },
  computed: {
    thirdPartyServices() {
      return this.$store.getters['ui/accountThirdPartyServices/itemsByParent'](this.accountId);
    },
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        if (newQuery.created || newQuery.updated) {
          this.fetchAccountThirdPartyServices();
        }
      },
    },
  },
  beforeRouteEnter: middleware('account-permission:read third party services'),
  created() {
    this.fetchAccountThirdPartyServices();
  },
  methods: {
    setLoading(value) {
      this.loading = Boolean(value);
    },
    setResolved(value) {
      this.resolved = Boolean(value);
    },
    setRejected(value) {
      this.rejected = Boolean(value);
    },
    setMessage(value) {
      this.message = value;
    },
    async fetchAccountThirdPartyServices() {
      try {
        this.setLoading(true);
        await this.$store.dispatch('ui/accountThirdPartyServices/load', {
          accountId: this.accountId,
        });
        this.setResolved(true);
      } catch (error) {
        this.setMessage = error?.response?.message || 'Something went wrong. Please try again.';
        this.setRejected(true);
      }
    },
  },
};
</script>
